/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'preview': {
    width: 21,
    height: 24,
    viewBox: '0 0 21 24',
    data: '<path pid="0" d="M14.293 17.374l-2.071-2.071a5.177 5.177 0 1 1 .707-.707l2.072 2.071a1.477 1.477 0 0 1 1.487.137V5.44h-2.86c-.679 0-1.229-.55-1.229-1.23V1.352H1.657a.23.23 0 0 0-.23.23v20.977c0 .127.103.23.23.23H16.26a.23.23 0 0 0 .23-.23v-1.611l-1.903-1.903a1.475 1.475 0 0 1-.293-1.67zm3.195.403l2.569 2.569a1.474 1.474 0 0 1-2.085 2.085l-.484-.484v.61c0 .68-.55 1.23-1.23 1.23h-14.6c-.68 0-1.23-.55-1.23-1.23V1.582C.428.9.978.35 1.658.35h10.939c.326 0 .639.13.87.36l3.66 3.662c.231.23.361.543.361.87v12.534zM15.781 4.44l-2.382-2.382v2.153c0 .126.103.23.23.23h2.152zm-3.896 3.913A4.176 4.176 0 1 0 5.98 14.26a4.176 4.176 0 0 0 5.905-5.906zm3.408 9.313a.474.474 0 0 0 0 .671l3.386 3.386a.474.474 0 0 0 .67-.67l-3.386-3.387a.474.474 0 0 0-.67 0z" _fill="#454545" fill-rule="nonzero"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/preview.js